import React, { useEffect, useRef, useState, useCallback } from "react";
import { Icon } from "../frame/Icon.jsx";
import { Nav } from "../frame/Nav.jsx";
import * as cls from "./dropDown.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  contractIdAction,
  contractNumberAction,
  resetNotifications,
  vuzIdAction,
} from "../../src/redux/actions/actions.js";
/**
 * @private
 * @author Айдарбек Артур уулу <kulubaev97@gmail.com>
 */
const CloseIcon = () => {
  return (
    <svg height="20" width="20" viewBox="0 0 20 20">
      <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
    </svg>
  );
};

const Dropdown = ({ onChange }) => {
  const [showMenu, setShowMenu] = useState(false);
  const { contractNumber, contracts } = useSelector((state) => state.contract);
  const [selectedValue, setSelectedValue] = useState(contractNumber || null);
  const [searchValue, setSearchValue] = useState("");
  const [copyText, setCopyText] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const dispatch = useDispatch();
  const searchRef = useRef();
  const inputRef = useRef();

  useEffect(() => {
    setSearchValue("");
    if (showMenu && searchRef.current) {
      searchRef.current.focus();
    }
  }, [showMenu]);

  useEffect(() => {
    const handler = (e) => {
      if (inputRef.current && !inputRef.current.contains(e.target)) {
        setShowMenu(false);
      }
    };

    window.addEventListener("click", handler);
    return () => {
      window.removeEventListener("click", handler);
    };
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setCopyText(false);
    }, 10000);
    return () => clearTimeout(timer);
  }, [copyText]);

  function handleInputClick() {
    setShowMenu(!showMenu);
    setCopyText(false);
  }

  const removeOption = useCallback(
    (option) => {
      return selectedValue.filter((o) => o.value !== option);
    },
    [selectedValue]
  );

  const onTagRemove = useCallback(
    (e, option) => {
      e.stopPropagation();
      const newValue = removeOption(option);
      setSelectedValue(newValue);
      onChange(newValue);
    },
    [onChange, removeOption]
  );

  const getDisplay = useCallback(() => {
    if (!selectedValue || selectedValue.length === 0) {
      let contract;
      for (const el of contracts) {
        if (el.main_contract) {
          contract = el;
        }
      }
      return contract.contract_number;
    }

    return selectedValue;
  }, [onTagRemove, contracts, selectedValue]);

  const onItemClick = (option) => {
    for (const contract of contracts) {
      if (contract.contract_number === option) {
        dispatch(resetNotifications());
        dispatch(contractIdAction(contract.study_contract_id));
        dispatch(contractNumberAction(option));
        dispatch(vuzIdAction(contract.vuz_id));
        setSelectedValue(option);
        onChange(option);
      }
    }
  };

  const isSelected = (option) => {
    if (!selectedValue) {
      return false;
    }

    return selectedValue.value === option;
  };

  const onSearch = (e) => {
    setSearchValue(e.target.value);
  };

  const getOptions = useCallback(() => {
    if (!searchValue) {
      return contracts.contract_number;
    }

    const arr = contracts.filter(
      (option) =>
        option.contract_number
          .toLowerCase()
          .indexOf(searchValue.toLowerCase()) >= 0
    );
    return arr;
  }, [contracts, searchValue]);

  function handleCopyClick() {
    navigator.clipboard.writeText(inputRef.current.children[0].textContent);
    setCopyText(true);
  }

  function handleClickClouse() {
    setCopyText(false);
  }
  useEffect(() => {
    if (selectedValue) {
    }
  }, [selectedValue]);
  const minWidth = 1030;
  useEffect(() => {
    setSelectedValue(contractNumber);
  }, [contractNumber]);
  React.useEffect(() => {
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  function onResize() {
    setScreenWidth(window.innerWidth);
  }
  const contractAction = {
    icon: "person",
    name: "Выбрать договор",
    onClick: (event) => {
      event.preventDefault();
      handleInputClick();
    },
  };
  return (
    <div
      className={
        screenWidth < minWidth
          ? cls.dropdown_container_mobile
          : cls.dropdown_container
      }
    >
      {screenWidth < minWidth ? (
        <Nav menu={[contractAction]} />
      ) : (
        <div className={cls.dropdown_inner}>
          <div
            className={cls.dropdown_copy_wrapper}
            onClick={() => handleCopyClick()}
            title="Скопировать номер договора"
          >
            <Icon name={!copyText ? "copy" : "check"} />
          </div>

          <div
            ref={inputRef}
            onClick={handleInputClick}
            className={cls.dropdown_input}
            title="Выбрать договор"
          >
            <div className={cls.dropdown_selected_value}>{getDisplay()}</div>
          </div>
          <div
            onClick={(e) => {
              e.stopPropagation();
              handleInputClick();
            }}
            className={cls.dropdown_icon_arrows}
            title="Выбрать договор"
          >
            <Icon name={showMenu ? "caret_up" : "caret_down"} />
          </div>
        </div>
      )}
      {showMenu && (
        <div className={cls.dropdown_menu}>
          {contracts.map((option) => {
            return (
              <div
                onClick={() => onItemClick(option.contract_number)}
                key={option}
                className={`${
                  option.in_study
                    ? cls.dropdown_item_bold
                    : cls.dropdown_item_gray
                } ${isSelected(option.contract_number) && "selected"}`}
              >
                {option.contract_number}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
